<template>
    <v-card class="round-card background-2 mt-4 pb-3" v-if="assets.length > 0">
        <v-card-title class="pa-3 cursor-pointer" @click="expanded = !expanded">
            <v-icon color="info" class="mr-2">mdi-desktop-tower</v-icon>
            <span class="subtitle-2">Asset ({{ assets.length }})</span>
            <v-spacer></v-spacer>
            <v-icon>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-card-title>

        <v-expand-transition>
            <div v-show="expanded">
                <v-divider></v-divider>
                <v-list dense class="pa-0 background-2">
                    <v-list-item
                        v-for="asset in assets"
                        :key="asset.id"
                        @click="openAsset(asset.id)"
                        class="cursor-pointer"
                    >
                        <v-list-item-content>
                            <v-list-item-subtitle class="d-flex align-center justify-space-between">
                                <span>{{ asset.code }}</span>
                                <v-chip v-if="asset.asset_type_text" x-small :color="asset.asset_type_color || 'grey'" dark>
                                    {{ asset.asset_type_text }}
                                </v-chip>
                            </v-list-item-subtitle>
                            <v-list-item-title class="d-flex align-center">
                                <span class="text-truncate">{{ asset.name }}</span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>
export default {
    name: 'CompanyAssets',

    props: {
        companyId: {
            type: Number,
            required: true
        },
        currentAssetId: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            assets: [],
            loading: false,
            expanded: true
        }
    },

    watch: {
        companyId: {
            immediate: true,
            handler(val) {
                if (val) this.loadAssets()
            }
        }
    },

    methods: {
        async loadAssets() {
            if (!this.companyId) return

            this.loading = true
            try {
                const params = {}
                if (this.currentAssetId) {
                    params.exclude_id = this.currentAssetId
                }
                const response = await this.axios.get(`helpdesktroubles/company/${this.companyId}/assets`, { params })
                this.assets = response.data.data || []
            } catch (error) {
                console.error('Error loading company assets:', error)
            } finally {
                this.loading = false
            }
        },

        openAsset(assetId) {
            const route = this.$router.resolve({
                name: 'assets-show',
                params: { id: assetId }
            })
            window.open(route.href, '_blank')
        }
    }
}
</script>
